<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-top:20px;margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/responsibility'}">目标责任管理</el-breadcrumb-item>
                <el-breadcrumb-item>上传</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form
                    :model="form"
                    :rules="rules"
                    label-width="100px"
                    class="demo-ruleForm"
                    style="width:80%;margin:0 auto"
            >
                <el-form-item label="文件" prop="name">
                    <el-upload
                            class="upload-demo"
                            drag
                            :fileList="fileList"
                            :on-change="handleChange"
                            multiple
                            :limit="1"
                            :on-exceed="handleExceed"
                            action="/v1/responsibilitybook/uploadFile"
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            将文件拖到此处，或
                            <em>点击上传</em>
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="文件类型" style="margin-bottom: 20px;" prop="bookType">
                    <div class="block">
                        <el-input v-model="form.bookType" id="remainder" size="small" style="width: 200px;"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="使用年度" style="margin-bottom: 20px;" prop="useYear">
                    <div class="block">
                        <el-input v-model="form.useYear" id="remainder" size="small" style="width: 200px;"></el-input>
                    </div>
                </el-form-item>

                <el-form-item label="审批人" style="margin-bottom: 20px;" prop="creatorId">
                    <div class="block">
                        <el-select size="small" v-model="form.creatorId" filterable placeholder="请选择" style="width: 200px">
                            <el-option
                                    v-for="item in userData"
                                    :key="item.id"
                                    :label="item.nickname"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-divider>责任人</el-divider>
                <el-form-item label="列表" prop="list" style="padding:10px 0;">
                    <div v-if="!isShowBtn" v-for="(item,index) in emergeData" :key="index">
                        <el-input :disabled="item.examineStatus == 1" size="small"
                                v-model="item.respPost"
                                style="width:200px;margin-left:20px"
                                placeholder="请输入责任人岗位"
                        ></el-input>
                        <el-select size="small" :disabled="item.examineStatus == 1" style="margin-left: 1%" v-model="item.respId" filterable placeholder="请选择">
                            <el-option
                                    v-for="item1 in userData"
                                    :key="item1.id"
                                    :label="item1.nickname"
                                    :value="item1.id">
                            </el-option>
                        </el-select>
                        <el-button v-if="item.examineStatus !=1" size="small"
                                type="danger"
                                icon="el-icon-delete"
                                style="margin-left:20px"
                                @click="handDelEme(index)"
                                circle
                        ></el-button>
                        <el-button v-if="item.examineStatus == 1" :disabled="true" size="small"
                                   type="info"
                                   style="margin-left:20px"
                        >已签</el-button>
                    </div>
                    <el-button size="small" type="primary" style="width:450px;margin-left: 1.7%;" @click="handleAddEme()" plain>添加</el-button>
                </el-form-item>
            </el-form>
            <div>
                <el-button type="primary" class="addBtn" @click="submitForm()">确定</el-button>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                isAdd:true,
                dialogVisible: false,
                form: {},
                rules: {
                    name: [{required: true, message: "请输入名称", trigger: "blur"}],
                },
                options: [],
                getObj: {},
                isShowBtn: true,
                isShowBtn2: true,
                emergeData: [],
                emergeData2: [],
                fileList: [],
                userData:[],
            };
        },
        mounted(){
            this.getUserData();
        },
        methods: {
            //获取用户 信息
            getUserData(){
                this.componentsMoudel.httpRequest
                    .getRequestHander("/businessManagement/userManagement/getAllUser")
                    .openLoad()
                    .startGet()
                    .then((res) => {
                        this.userData = res.body.data;
                    });
            },
            handleChange(file, fileList) {
                this.fileList = fileList.slice(-3);
            },
            handDelEme(index) {
                // console.log(index);
                this.emergeData.splice(index, 1);
            },
            handleAddEme() {
                this.isShowBtn = false;
                this.emergeData.push({
                });
            },
            // 限制文件上传个数
            handleExceed(files, fileList) {
              this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },

            submitForm() {
                let url = "";
                if (this.isAdd){
                    url = this.componentsMoudel.getData("urls").saveResponsibility;
                } else{
                    url = "/responsibilitybook/update"
                }
                var fileArray = [];
                for (let item in this.fileList) {
                    var fileInfo = {};
                    fileInfo.fileName = this.fileList[item].name;
                    fileInfo.url = this.fileList[item].response.data;
                    fileArray.push(fileInfo);
                }
                this.form.platformFile = fileArray;
                this.form.responsibleDep = this.emergeData;
                this.componentsMoudel.httpRequest
                    .getRequestHander(url)
                    .openLoad()
                    .startPost(this.form)
                    .then((res) => {
                        this.$message({
                            showClose: true,
                            message: "添加成功",
                            type: "success",
                        });

                        this.$router.push({
                            path: "/processManager/responsibility",
                        });
                    });
            },
        },
        created() {
            let obj = this.$route.params.key;
            if (this.$route.params.key) {
                this.form = obj;
                this.isAdd = false;
                this.form.creatorId = parseInt(this.form.creatorId);
                let file = {
                    name:this.form.bookFileName,
                    response:{
                        data:this.form.bookUrl
                    }
                };
                this.fileList.push(file);
                for (let j = 0; j < obj.depVos.length; j++) {
                    let name =  obj.depVos[j].respPost;
                    let input = parseInt(obj.depVos[j].respId);
                    this.emergeData.push({
                        respPost:name,
                        respId:input,
                        examineStatus:obj.depVos[j].examineStatus
                    });
                }
                this.handleAddEme();
                let length = this.emergeData.length;
                this.emergeData.splice(length-1, 1);

            } else {
                this.ruleForm = {
                };
            }

        },
    };
</script>

<style scoped>
    .addBtn {
        display: block;
        width: 300px;
        margin: 0 auto;
    }

    .head {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 60px;
    }

    .content {
        background-color: #FFFFFF;
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 10px;
        border: 1px solid #e9eef3;
    }

</style>
